@if(!isLoading) {
<div class="container" [class.is_mobile]="isMobile">

  <!-- Formulário aparece apenas quando não há resultados carregados e não está carregando -->
  <div *ngIf="(editingMode || !resultTest) && !isLoading" style="text-align: left; width: 100%">

    <!-- Active Filters Counter -->
    <div *ngIf="activeFilters.length > 0" style="margin-bottom: 16px;">
      <app-active-filters-counter
        [filters]="activeFilters"
        (filterRemoved)="onFilterRemoved($event)"
        (filterClicked)="onFilterClicked($event)"
        (clearAllClicked)="onClearAllFilters()">
      </app-active-filters-counter>
    </div>

    <form [formGroup]="searchForm">
      <!-- Seção: Informações da oferta de exames e terapias -->
      <div class="form-section">
        @if(searchConfig?.type == 'OFFERING'){
        <h3>Informações da oferta de exames e terapias</h3>
        } @else {
        <h3>Informações da demanda de exames e terapias</h3>
        }

        <div class="multiColumns">
          <div class="column">
            <mat-form-field appearance="outline" floatLabel="always">
              <mat-label>
                Categoria de exames e terapias
                <mat-icon 
                  class="help-icon" 
                  matTooltip="Selecione se deseja buscar por exames ou terapias. Este campo determina os tipos disponíveis para seleção."
                  matTooltipPosition="right"
                  [matTooltipTouchGestures]="'on'">
                  help_outline
                </mat-icon>
              </mat-label>
              <mat-select formControlName="resourceCategory">
                <mat-option value="">Selecione uma categoria</mat-option>
                <mat-option value="exames">Exames</mat-option>
                <mat-option value="terapias">Terapias</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <!-- Resource Selection -->
        @if(showResourceSelection) {
        <div class="column">
          <fieldset class="resource-fieldset">
            <legend>Tipos de {{
              searchForm.get('resourceCategory')?.value === 'exames' ? 'Exames' :
              searchForm.get('resourceCategory')?.value === 'terapias' ? 'Terapias' :
              'Exames e terapias'
              }}:</legend>
            <div formArrayName="resourceTypes">
              <div class="column-items">
                @for(resource of getResourceOptions(); track resource.key; let i = $index) {
                <mat-checkbox [checked]="resourceTypesArray.at(i).value"
                  (change)="onResourceCheckboxChange(i, $event.checked)">
                  {{ resource.label }}
                </mat-checkbox>
                }
              </div>
            </div>
          </fieldset>

        </div>
        <div class="multiColumns">
          <div class="column">
            <mat-form-field appearance="outline" floatLabel="always">
              <mat-label>
                Publicado apartir de
                <mat-icon 
                  class="help-icon" 
                  matTooltip="Filtre por data de publicação inicial. Apenas ofertas/demandas publicadas a partir desta data serão exibidas."
                  matTooltipPosition="right"
                  [matTooltipTouchGestures]="'on'">
                  help_outline
                </mat-icon>
              </mat-label>
              <input matInput [matDatepicker]="picker" formControlName="publicationDateFrom" />

              <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="column">
            <mat-form-field appearance="outline" floatLabel="always">
              <mat-label>
                Publica até
                <mat-icon 
                  class="help-icon" 
                  matTooltip="Filtre por data de publicação final. Apenas ofertas/demandas publicadas até esta data serão exibidas."
                  matTooltipPosition="right"
                  [matTooltipTouchGestures]="'on'">
                  help_outline
                </mat-icon>
              </mat-label>
              <input matInput [matDatepicker]="picker2" formControlName="publicationDateTo" />

              <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
              <mat-datepicker #picker2></mat-datepicker>
            </mat-form-field>
          </div>
        </div>

        }
      </div>

      <!-- Seção: Localização -->
      <div class="form-section">
        <h3>Localização</h3>

        <div class="multiColumns">
          <div class="column">
            <mat-form-field appearance="outline" floatLabel="always">
              <mat-label>
                Estado
                <mat-icon 
                  class="help-icon" 
                  matTooltip="Selecione o estado para filtrar as cidades disponíveis."
                  matTooltipPosition="right"
                  [matTooltipTouchGestures]="'on'">
                  help_outline
                </mat-icon>
              </mat-label>
              <mat-select formControlName="state">
                <mat-option value="">Selecione um estado</mat-option>
                <mat-option *ngFor="let state of states" [value]="state.code">
                  {{state.name}} ({{state.code}})
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="multiColumns">
          <div class="column">
            <mat-form-field appearance="outline" floatLabel="always">
              <mat-label>
                Cidade de Referência
                <mat-icon 
                  class="help-icon" 
                  matTooltip="Selecione a cidade central para a busca. Cidades próximas serão calculadas com base no raio especificado."
                  matTooltipPosition="right"
                  [matTooltipTouchGestures]="'on'">
                  help_outline
                </mat-icon>
              </mat-label>
              <mat-select formControlName="referenceCity">
                <mat-option value="">Selecione uma cidade</mat-option>
                <mat-option *ngFor="let city of cities" [value]="city.nome">
                  {{city.nome}}
                </mat-option>
              </mat-select>
              <mat-hint *ngIf="isLoading">Carregando cidades...</mat-hint>
            </mat-form-field>
          </div>

          <div class="column">
            <mat-form-field appearance="outline" floatLabel="always">
              <mat-label>
                Raio (km)
                <mat-icon 
                  class="help-icon" 
                  matTooltip="Defina o raio de busca em quilômetros. Valor mínimo: 0 km, Valor máximo: 80 km. Cidades dentro deste raio serão incluídas na busca."
                  matTooltipPosition="right"
                  [matTooltipTouchGestures]="'on'">
                  help_outline
                </mat-icon>
              </mat-label>
              <input matInput type="number" formControlName="radiusInKm">
              <mat-icon matSuffix *ngIf="showSuccess('radiusInKm')" class="success-icon">check_circle</mat-icon>
              <mat-error *ngIf="showError('radiusInKm')">{{ getErrorMessage('radiusInKm') }}</mat-error>
              <mat-hint *ngIf="!showError('radiusInKm')">Máximo: 80 km</mat-hint>
            </mat-form-field>
          </div>
        </div>

        <div *ngIf="nearbyCities.length > 0" class="nearby-cities">
          <app-city-chips-selector
            [availableCities]="nearbyCities"
            [selectedCities]="selectedCities"
            (selectionChange)="onCitySelectionChange($event)">
          </app-city-chips-selector>
        </div>
      </div>

      <!-- Seção: Detalhes da oferta de exames e terapias -->
      <div class="form-section">
        <h3>Detalhes de exames e terapias</h3>

        <div class="multiColumns">

          <div class="column">
            <mat-label>
              Disponibilidade
              <mat-icon 
                class="help-icon" 
                matTooltip="Selecione os períodos de disponibilidade desejados. Clique nos blocos para marcar/desmarcar dias e horários."
                matTooltipPosition="right"
                [matTooltipTouchGestures]="'on'">
                help_outline
              </mat-icon>
            </mat-label>
            <app-availability [availability]="availability" (availabilityChange)="onAvailabilityChange($event)"
              [editable]="true">
            </app-availability>
          </div>
        </div>
      </div>

      <div class="footerButtons">
        <button mat-button type="button" (click)="resetForm()">
          Limpar
          <mat-icon>clear</mat-icon>
        </button>
        <button mat-flat-button color="primary" type="submit" [disabled]="!canSearch()" (click)="submitSearch()">
          Buscar
          <mat-icon>search</mat-icon>
        </button>
      </div>
    </form>

    <div *ngIf="isLoading && !cities.length" class="loading-container">
      <mat-spinner></mat-spinner>
      <p>Carregando...</p>
    </div>
  </div>

</div>


<!-- Results: use the reusable AdvancedSearchResultsComponent -->
<div *ngIf="resultTest && !editingMode">
  <!-- Cache indicator and actions -->
  <div class="results-header" style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px;flex-wrap:wrap;gap:8px;">
    <div *ngIf="isFromCache" class="cache-indicator" style="display:flex;align-items:center;gap:8px;color:var(--color-primary);font-size:14px;">
      <mat-icon style="font-size:20px;width:20px;height:20px;">cached</mat-icon>
      <span>Resultados em cache</span>
    </div>
    
    <!-- <div class="results-actions" style="display:flex;gap:8px;">
      <button mat-stroked-button color="primary" (click)="refreshSearch()" [disabled]="isLoading" matTooltip="Atualizar resultados ignorando cache">
        <mat-icon>refresh</mat-icon>
        Atualizar
      </button>
      <button mat-stroked-button color="primary" (click)="editingMode = true">
        <mat-icon>edit</mat-icon>
        Alterar pesquisa
      </button>
      <button mat-stroked-button color="primary" (click)="newSearch()">
        <mat-icon>search</mat-icon>
        Nova pesquisa
      </button>
    </div> -->
  </div>

  <app-advanced-search-resource-results [items]="resultTest.content || []" [isLoading]="isLoading"
    [serverSide]="true" [length]="resultTest.page?.totalElements || 0" [pageSize]="pageSize"
    [searchConfig]="searchConfig" (page)="onPageChange($event)">
  </app-advanced-search-resource-results>

</div>
}